import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCheckCircle, FiEye, FiClock, FiTrendingUp } = FiIcons;

const Benefits = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  const benefits = [
    {
      icon: FiCheckCircle,
      title: "Einheitliche Qualität & Prozessoptimierung",
      description: "Konsistente Vorgehensweise und gleichbleibend hohe Qualität in jeder automatisierten Kundeninteraktion"
    },
    {
      icon: FiEye,
      title: "Transparente Dokumentation",
      description: "Vollständige Transkripte aller Gespräche für nachvollziehbare Dokumentation und Compliance-Anforderungen"
    },
    {
      icon: FiClock,
      title: "Effizienzsteigerung & Kostensenkung",
      description: "Mehr Zeit für wertschöpfende Tätigkeiten – Konzentration auf strategische Aufgaben statt Routinearbeiten"
    },
    {
      icon: FiTrendingUp,
      title: "Zukunftssichere Digitalisierung",
      description: "Skalierbare KI-Lösungen, die mit deinem Unternehmenswachstum mitwachsen und langfristig Wettbewerbsvorteile schaffen"
    }
  ];

  return (
    <section className="py-20 bg-gray-50" ref={ref}>
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
          transition={{ duration: 0.8 }}
          className="max-w-6xl mx-auto"
        >
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-black mb-8">
              Vorteile der KI-Automatisierung
            </h2>
            <div className="w-24 h-1 bg-azure-600 mx-auto mb-12"></div>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {benefits.map((benefit, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
                animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
                className="flex items-start space-x-6 p-8 bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300"
              >
                <SafeIcon 
                  icon={benefit.icon} 
                  className="text-3xl text-azure-600 mt-1 flex-shrink-0" 
                />
                <div>
                  <h3 className="text-xl font-semibold text-black mb-3">{benefit.title}</h3>
                  <p className="text-gray-700 leading-relaxed">{benefit.description}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Benefits;